import { InformationCircleIcon } from "icons/outline";
import React, { useEffect, useState } from "react";
import { DropdownSearch, type DropdownOption } from "ui";
import FormFieldError from "./FormFieldError";

type ChoiceFieldProps = {
  type?: React.InputHTMLAttributes<HTMLInputElement>;
  value: string;
  required?: boolean;
  field_name: string;
  min_length?: number | null;
  max_length?: number | null;
  label: React.ReactNode;
  help_text?: string;
  error_messages: Record<string, string>;
  choices: Record<string, string>;
  onChange: (name: string, value: string) => void;
};

const ChoiceField: React.FC<ChoiceFieldProps> = ({
  value,
  field_name,
  label,
  help_text,
  error_messages,
  choices,
  onChange,
}) => {
  const [options, setOptions] = useState<DropdownOption<string>[]>([]);
  const [choiceValue, setChoiceValue] = useState<DropdownOption<string>>(
    value ? [`${value}`, choices[value]] : ["", ""]
  );

  useEffect(() => {
    setOptions(Object.keys(choices).map((key) => [key, choices[key]]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="sm:col-span-4" key={field_name}>
        <label
          htmlFor="location"
          className="block text-sm font-medium text-foundations-bold"
        >
          {label}
        </label>
        <div className="mt-1">
          <DropdownSearch
            key={field_name}
            name={field_name}
            label={`Select ${label}`}
            selected={choiceValue}
            options={options}
            onSelect={([value]: DropdownOption<string>) => {
              onChange(field_name, value);
              setChoiceValue([value, choices[value]]);
            }}
          />
        </div>
        {help_text && (
          <p
            className="mt-2 inline-flex items-center text-sm text-foundations-subtle"
            id="email-description"
          >
            <InformationCircleIcon className="h-4 w-4" />
            <span className="pl-1">{help_text}</span>
          </p>
        )}
      </div>
      <FormFieldError
        className="sm:col-span-6"
        errors={error_messages}
        name={field_name}
      />
    </>
  );
};

export default ChoiceField;
